import * as React from 'react';

import Bell140 from './Bell140';

export const bell140 = () => <Bell140 />;

export default {
    title: 'Illustration|Bell140',
    component: Bell140,
    parameters: {
        notes: "`import Bell140 from 'box-ui-elements/es/illustration/Bell140';`",
    },
};
